<script setup>
import { computed, toRef } from 'vue';
import { useSeleccionMultiple } from '@/composables/useSeleccionMultiple';

const seleccionados = defineModel({ type: Array, default: () => [] });

const props = defineProps({
  valores: { type: Array, default: () => [] },
  size: { type: String, default: 'xs' },
  disabled: { type: Boolean, default: false },
  busquedaCompletaMarcada: { type: Boolean, default: false },
});

const valoresRef = toRef(props, 'valores');
const { todosSeleccionados, toggleTodos } = useSeleccionMultiple(seleccionados, valoresRef);

const iconoClase = computed(() => {
  if (props.busquedaCompletaMarcada) {
    return 'fa-check-double';
  }
  return todosSeleccionados.value ? 'fa-check-square' : 'fa-square';
});
</script>

<template>
  <button
    type="button"
    class="btn btn-default boton-seleccionar-todo as-check"
    :class="`btn-${size}`"
    :disabled="disabled"
    @click="toggleTodos"
  >
    <i class="fa" :class="iconoClase"></i>
  </button>
</template>
